import { makeStyles } from '@material-ui/core/styles'

const headerStyles = makeStyles(theme => ({
  programHeaderBar: {
    margin: '2% 2% 1.3%',
    height: 'auto',
    background: '#FFFFFF',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  programDetailsDynamic: {
    display: 'flex',
    alignItems: 'center', //vertical center of the parent element
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    marginBottom: '10px',
    minWidth: '0px'
    // width: '100%'
  },
  programDetailsStatic: {
    display: 'flex',
    alignItems: 'center', //vertical center of the parent element
    flexWrap: 'wrap',
    justifyContent: 'center',
    marginLeft: 'auto'
    // width: '100%'
  },
  button: {
    marginBottom: '5px'
  },
  programTitle: {
    // border : '2px solid black',
    display: 'block',
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '38px',
    marginRight: '5px',
    maxWidth: '720px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  staticMargin: {
    marginLeft: '10px'
  },
  popWrapper: {
    padding: '30px',
    color: '#565657',
    fontSize: '16px',
    textAlign: 'center'
  },
  ackButton: {
    marginTop: '20px',
    width: 'auto',
    height: 'auto'
  },
  popText: {
    fontSize: '18px'
  },
  customPaper: {
    maxWidth: '550px'
  },
  popupTitle: {
    color: '#545455',
    fontSize: '18px',
    marginTop: '-12px',
    fontWeight: 600
  },
  formTitle: {
    color: '#545455',
    opacity: 0.7,
    fontSize: '14px'
  },
  confirmDescription: {
    color: '#606060',
    fontSize: '14px'
  },
  checkboxRoot: {
    padding: 0,
    margin: '2px 10px 0px 0px',
    display: 'flex',
    alignItems: 'start'
  },
  notifyTitle: {
    color: '#545455',
    fontWeight: 600,
    fontSize: '18px',
    textAlign: 'center'
  },
  messageTitle: {
    color: '#545455',
    fontSize: '18px',
    fontWeight: 600
  },
  messageText: {
    color: '#545455',
    fontSize: '14px',
    opacity: '70%',
    textAlign: 'center',
  }
}))

export { headerStyles }